var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "meta_data",
    attrs: {
      "id": "validators_meta"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Staking Distribution")]), _c('v-tabs', {
    staticClass: "tabs",
    attrs: {
      "active-class": "tab_active",
      "height": "32",
      "hide-slider": ""
    },
    on: {
      "change": _vm.typeChange
    }
  }, [_c('v-tab', [_vm._v("Active")]), _c('v-tab', [_vm._v("Pending")])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }